
  import {Component, Vue, Watch} from "vue-property-decorator";
import { getOperationNameByMac } from "@/api/monitorGateway";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
import { LogHelper } from "@/common/LogHelper";
  import Enumerable from "linq";

@Component({
  name: "Form1",
})
export default class extends Vue {
  private inputModel: inputDataModel_DisCard = {
    input_ScanCode: "",
    discardType:"",
    discardTypeLabel: "",
    circleLine: 0,
    maxLatticeNo: 0,
    deviceAttribute: 0
  };
  public globalConfig: any = {};
  public latticeNoRequired = false;
  public discardType = "";
  public  discardTypeData= [{
    value: '1',
    label: '有责报废'
  }, {
    value: '2',
    label: '无责出售'
  },{
    value: '3',
    label: '短袋出售'
  }];

  @Watch("inputModel.discardType", {deep: false})
  onPackageNameChanged(val: string, oldVal: string) {
    debugger;
    let c = Enumerable.from(this.discardTypeData);
    let item:any = c.firstOrDefault(  f=> f.value === this.inputModel.discardType);

    if (item)
    {
      console.log("*************" + item.value + ";" + item.label);
      this.inputModel.discardTypeLabel = item.label;
    }
  }

  mounted() {
    this.globalConfig = SystemConfigModule.globalData;
    try {
      this.inputModel.discardType = "";
    } catch (error) {
      console.log(error);
    }
    this.$emit("get-form1-value", this.inputModel);
  }
}
